'use client';

import { useSpring, animated } from '@react-spring/web';
import { forwardRef } from 'react';

interface TransitionProps {
  in?: boolean;
  onEnter: () => void;
  onExited: () => void;
}

export const Animation = forwardRef<HTMLDivElement, TransitionProps>(
  ({ in: open, onEnter, onExited, ...props }, ref) => {
    const styles = useSpring({
      config: { duration: 150 },
      from: { opacity: 0, transform: 'translateY(5%)' },
      to: {
        opacity: open ? 1 : 0,
        transform: open ? 'translateY(0%)' : 'translateY(5%)',
      },
      onStart: () => {
        if (open && onEnter) {
          onEnter();
        }
      },
      onRest: () => {
        if (!open && onExited) {
          onExited();
        }
      },
    });

    return <animated.div ref={ref} style={{ ...styles }} {...props} />;
  }
);
